import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {BreakpointObserver} from "@angular/cdk/layout";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {FormControl, FormGroup} from "@angular/forms";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {User} from "../../../objects/user";
import {transferArrayItem} from "@angular/cdk/drag-drop";

@Component({
  selector: 'app-event-item-view',
  templateUrl: './event-item-view.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class EventItemViewComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();

  listItem:ListItem;
  eventPayload:object;
  parentEventPayload:object;
  state = 'default'
  mode = 'default'  //edit_game/loading/default
  //allowGameEditMode = false

  allowEventEdit = false
  allowEventComment = false
  allowEventCancel = false
  allowEventDelete = false

  allowFullView = false
  profileLeft:User = new User()
  profileRight:User = new User()
  public componentForm: FormGroup = new FormGroup({});
  public scoreLeft: FormControl = new FormControl(1);
  public scoreRight: FormControl = new FormControl(1);

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.mode = this.payload['mode'] ? this.payload['mode'] : this.mode;
    if(this.mode === 'edit_game') {
      this.componentForm.addControl('scoreLeft', this.scoreLeft);
      this.componentForm.addControl('scoreRight', this.scoreRight);
    }

    this.listItem = this.payload['item'];
    this.eventPayload = this.listItem['itemFullData']['payload_parsed'];
    let trainerID = this.eventPayload['trainer_id'];
    this.parentEventPayload = this.listItem['itemFullData']['parent_payload_parsed'];
    console.log('this.eventPayload',this.listItem,this.eventPayload,this.parentEventPayload);
    switch (this.eventPayload['type']) {
      // case 'squashtime_game_finish':
      // case 'game_finish':
      // case 'tournament_game_finish':
      case 'game_proposal':
      case 'tournament_game_proposal':
      case 'trainer_booking_add':
      case 'trainer_booking_cancel':
        this.state = 'split';
        break;
      default:
        this.state = 'default';
    }

    if(User.isTrainer(this.application.user) ||
      this.listItem['itemFullData']['profile_id'] == this.application.user.id ||
      (this.listItem['itemFullData']['profileData'] && User.checkProfilesForGame(this.application.user,this.listItem['itemFullData']['profileData'])) ||
      (this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => profile['id'] == this.application.user.id )) ||
      (this.eventPayload['profiles'] && this.eventPayload['profiles'].length == 2
       && User.checkProfilesForGame(this.application.user,this.eventPayload['profiles'][0])
       && User.checkProfilesForGame(this.application.user,this.eventPayload['profiles'][1])
      )) {
      this.allowFullView = true;
    }

    // console.log('allowFullView1',User.isTrainer(this.application.user),this.listItem['itemFullData']['profile_id'] == this.application.user.id);
    // console.log('allowFullView2',(this.listItem['itemFullData']['profileData'] && User.checkProfilesForGame(this.application.user,this.listItem['itemFullData']['profileData'])));
    // console.log('allowFullView3',(this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => profile['id'] == this.application.user.id )));
    // console.log('allowFullView4',(this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => User.checkProfilesForGame(this.application.user,profile) )));

    // if(this.state === 'split' && (User.isOwner(this.application.user) ||
    //   User.isTrainer(this.application.user) && this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => profile['id'] == this.application.user.id ))) {
    //   this.allowEventComment = true;
    // }

    this.setEditControls();

    // if(User.isOwner(this.application.user)) {
    //   this.allowEventDelete = true;
    // } else if(User.isTrainer(this.application.user) &&
    //   this.listItem['itemFullData']['profile_id'] == this.application.user.id) {
    //   this.allowEventDelete = true;
    // }

    // if(this.eventPayload['type'] == 'trainer_booking_add') { //for now training cancelling only throughout trainer's Calendar (calendar-event-form.component.ts)
    //   this.allowEventDelete = false;
    // }

    if(this.eventPayload['type'] == 'game_proposal' && this.application.user.id == this.listItem['itemFullData']['id']) {
      //this.allowGameEditMode = true;
    } else if(this.state === 'split') {
      this.profileLeft = this.eventPayload['profiles'][0];
      this.profileRight = this.eventPayload['profiles'][1];
    } else {
      this.profileLeft = this.payload['item']['itemFullData']['profileData'];
    }

    if(!this.allowFullView && !User.checkProfilesForGame(this.application.user,this.profileLeft) && this.profileLeft['id']!=trainerID) {
      this.profileLeft['shipping_name'] = AppComponent.extractUserName(this.profileLeft['shipping_name']);
    }
    if(this.profileRight && !this.allowFullView && !User.checkProfilesForGame(this.application.user,this.profileRight) && this.profileRight['id']!=trainerID) {
      this.profileRight['shipping_name'] = AppComponent.extractUserName(this.profileRight['shipping_name']);
    }
  }

  public setEditControls(): void {
    //reset statuses
    this.allowEventEdit = false
    this.allowEventComment = false
    this.allowEventCancel = false
    this.allowEventDelete = false

    if(User.isOwner(this.application.user) ||
      User.isTrainer(this.application.user) && this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => profile['id'] == this.application.user.id ) ||
      this.listItem['itemFullData']['profile_id'] == this.application.user.id) {
      this.allowEventComment = true;
    }

    if(this.eventPayload['type'] == 'trainer_booking_add') {
      if(User.isOwner(this.application.user) ||
         this.application.account.payload_parsed['allow_trainer_to_cancel_training'] && User.isTrainer(this.application.user) && this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => profile['id'] == this.application.user.id )) {
        this.allowEventEdit = true;
        this.allowEventCancel = true;
      }
    } else if(this.eventPayload['type'] == 'trainer_booking_cancel') {
      if(User.isOwner(this.application.user) ||
         this.application.account.payload_parsed['allow_trainer_to_cancel_training'] && User.isTrainer(this.application.user) && this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => profile['id'] == this.application.user.id )) {
        this.allowEventEdit = true;
        this.allowEventDelete = true;
      }
    } else if(this.eventPayload['type'] == 'game_proposal') {
      if(User.isOwner(this.application.user) ||
        User.isTrainer(this.application.user) && this.eventPayload['profiles'] && this.eventPayload['profiles'].find(profile => profile['id'] == this.application.user.id )) {
        this.allowEventDelete = true;
      }
    }
  }

  public editClick(): void {
    //todo
    //open trainer-calendar-event-form and load data from purchase_id
    console.log('eventPayload',this.eventPayload)
  }
  public commentClick(): void {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'message-popup',
        payload: {old_message: this.eventPayload['comment'], 'popup_state': 'comment'},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload && dialogPayload['message']) {
          let oldItemFullData = JSON.parse(JSON.stringify(this.listItem.itemFullData)) //clone
          this.eventPayload['comment'] = dialogPayload['message'];
          this.listItem['itemFullData']['payload'] = JSON.stringify(this.eventPayload);
          this.saveEvent(oldItemFullData)
        }
      })
  }
  public cancelItem(): void {
    if( !['trainer_booking_add'].includes(this.eventPayload['type']) ) return; //maybe more cancel types in future
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: 'auto',
      data: {
        application: this.application,
        state: 'event-delete',
        payload: {
          item: this.listItem,
          isCanceling: this.listItem
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) { //todo 4 options: 🔥 refundable - convert to type, convert to type with no refund (add $eventPayload->no_refund and apply in bot), delete with usage restore, delete without usage restore
          let oldItemFullData = JSON.parse(JSON.stringify(this.listItem.itemFullData)) //clone
          if(this.eventPayload['type'] == 'trainer_booking_add') {
            this.eventPayload['type'] = 'trainer_booking_cancel';
            this.listItem['itemFullData']['payload'] = JSON.stringify(this.eventPayload);
            this.saveEvent(oldItemFullData,'training_cancel')
          } //todo more types
        }
      })
  }
  public saveEvent(oldItemFullData,changeAction = ''): void {
    this.mode = 'loading';
    this.application.apiService.updateEvent(environment['gid'],environment['g_hash'],this.listItem.itemFullData,changeAction)
      .subscribe(
        data => {
          this.setEditControls();
          this.mode = 'default';
          let appEvent = new AppEvent(AppEvent.EVENT_UPDATED, {item: this.listItem,changeAction: changeAction});
          this.application.sharedDataService.pushAppEvent(appEvent)
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Updated!';
          this.application.sharedDataService.pushNotification(notification);
        },
        error => {
          this.mode = 'error';
          //revert value
          this.listItem.itemFullData = { ...oldItemFullData };
          const { exception } = error;
          if (exception && exception.statusText) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.statusText;
            this.application.sharedDataService.pushNotification(notification);
          }
        }
      )
  }
  public saveGame(): void {
    this.listItem.itemFullData['payload_parsed']['profiles'] = [this.profileLeft,this.profileRight]
    this.listItem.itemFullData['payload_parsed']['player_id'] = this.profileLeft['id']
    this.listItem.itemFullData['payload_parsed']['vizavi_id'] = this.profileRight['id']
    this.listItem.itemFullData['payload_parsed']['pickedTime'] = ((new Date()).getTime())/1000
    if(this.scoreLeft.value == this.scoreRight.value) {
      this.listItem.itemFullData['payload_parsed']['result'] = 'draw';
    } else if(parseInt(this.scoreLeft.value) > parseInt(this.scoreRight.value)) {
      this.listItem.itemFullData['payload_parsed']['result'] = 'win';
    } else {
      this.listItem.itemFullData['payload_parsed']['result'] = 'lose';
    }
    this.listItem.itemFullData['payload_parsed']['score'] = this.scoreLeft.value+':'+this.scoreRight.value
    this.mode = 'loading';
    this.application.apiService.saveGame(environment['gid'],environment['g_hash'],this.listItem.itemFullData['cid'],this.listItem.itemFullData['class_uuid'],this.listItem.itemFullData['payload_parsed'])
      .subscribe(
        data => {
          this.mode = 'default';
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Saved!';
          this.application.sharedDataService.pushNotification(notification);
          let appEvent = new AppEvent(AppEvent.GAME_CREATED, null);
          this.application.sharedDataService.pushAppEvent(appEvent)
          this.close.emit()
        },
        error => {
          this.mode = 'error';
          const { exception } = error;
          if (exception && exception.statusText) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.statusText;
            this.application.sharedDataService.pushNotification(notification);
          }
        }
      )
  }
  public deleteItem() {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: 'auto',
      data: {
        application: this.application,
        state: 'event-delete',
        payload: {
          item: this.listItem,
          isCanceling: this.listItem
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
          this.doItemDelete()
        }
      })
  }
  protected doItemDelete() {
    this.mode = 'loading';
    this.application.apiService.deleteEvent(environment['gid'],environment['g_hash'],this.listItem.itemFullData)
      .subscribe(
        data => {
          this.mode = 'default';
          if(this.eventPayload['type'] == 'game_proposal' && this.eventPayload['status'] != 'canceled') {
            this.eventPayload['status'] = 'canceled';
            this.listItem['itemFullData']['payload'] = JSON.stringify(this.eventPayload);
            this.setEditControls();
            let appEvent = new AppEvent(AppEvent.EVENT_UPDATED, {item: this.listItem});
            this.application.sharedDataService.pushAppEvent(appEvent)
          } else {
            let appEvent = new AppEvent(AppEvent.EVENT_DELETED, {item: this.listItem});
            this.application.sharedDataService.pushAppEvent(appEvent)
          }
          this.close.emit()
        },
        error => {
          this.mode = 'error';
          const { exception } = error;
          if (exception && exception.statusText) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.statusText;
            this.application.sharedDataService.pushNotification(notification);
          }
        }
      )
  }

  public clickUser(user, leftRight = ''): void {
    if(this.mode == 'edit_game') {
      this.showUsersPicker(leftRight)
    } else {
      this.onNoClick();
      this.application.router.navigateByUrl('/squash/userview/'+user.id)
    }
  }

  public showUsersPicker(leftRight): void {
    let payloadUsers = this.payload['users'].filter(
      elem => elem['itemFullData']['id']!=this.profileLeft['id'] && elem['itemFullData']['id']!=this.profileRight['id'])
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'user-pick',
        payload: {users: payloadUsers},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload) {
          switch (leftRight) {
            case 'left':
              this.profileLeft = dialogPayload['user']['itemFullData']
              break;
            case 'right':
              this.profileRight = dialogPayload['user']['itemFullData']
              break;
          }
        }
      })
  }

  public showClass(user): void {
    this.onNoClick();
    this.application.router.navigateByUrl('/squash/userview/'+user.id)
  }

  public onNoClick(): void {
    this.close.emit()
  }

}
